import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '01',
  value: '37 CHF',
  title: 'Das Quadrilinguale Technische Lexikon',
  desc: '850+ Fachbegriffe in Deutsch, Französisch, Englisch und Italienisch. Unterrichte jeden internationalen Kunden in seiner Sprache mit präziser technischer Terminologie.'
}, {
  num: '02',
  value: '47 CHF',
  title: 'Der Wetter und Sicherheits-Guide',
  desc: 'Lawinenbeurteilung, Wetteranalyse, FIS-Regelwerk und vollständige Erste-Hilfe-Protokolle für alpine Notfallsituationen. Dein professioneller und rechtlicher Schutzschild.'
}, {
  num: '03',
  value: '33 CHF',
  title: 'Das Checklisten-System — 18 Feldkarten',
  desc: 'Tägliche Morgenroutine, Ausrüstungskontrolle, Lawinenentscheidungssystem und REGA-Alarmprotokoll mit allen Schweizer Notfallnummern. Laminiert. Immer in der Jackentasche.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden bg-white" data-id="element-21">
      <div className="absolute inset-0 bg-brand-gold/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-22" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-24">
          <div className="bg-brand-gold/10 p-3 rounded-full mb-3" data-id="element-25">
            <GiftIcon className="w-8 h-8 text-brand-gold" data-id="element-26" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-brand-navy mb-2" data-id="element-27">
            3 Boni gratis mit deinem System
          </h2>
          <p className="text-sm text-brand-navy font-bold" data-id="element-28">
            Gesamtwert: 117 CHF · Heute:{' '}
            <span className="text-brand-red" data-id="element-29">0.00 CHF</span>
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-30">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border border-brand-gold/30 p-5 rounded-2xl shadow-sm" data-id="element-31">
              <div className="flex items-center gap-2 mb-2" data-id="element-32">
                <span className="text-brand-gold font-black text-xs tracking-widest" data-id="element-33">
                  BONUS {bonus.num}
                </span>
                <span className="text-brand-border" data-id="element-34">|</span>
                <span className="text-xs font-black text-brand-navy uppercase" data-id="element-35">
                  {bonus.value} — GRATIS
                </span>
              </div>
              <div className="flex items-start gap-2 mb-2" data-id="element-36">
                <span className="text-2xl" data-id="element-37">🎁</span>
                <h3 className="text-base sm:text-lg font-bold text-brand-navy leading-tight" data-id="element-38">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-sm text-brand-text font-medium leading-snug" data-id="element-39">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}